"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOS = exports.DESKTOP = exports.ANDROID = void 0;
exports.ANDROID = 'android';
exports.DESKTOP = 'desktop';
exports.IOS = 'iOS';
